import { inject, Injectable } from '@angular/core';
import { SupabaseService } from '../../services/supabase.service';
import { v4 as uuidv4 } from 'uuid';
import { AuthService } from '../../services/auth/auth.service';

@Injectable({providedIn: 'root'})
export class ImageApi {
  supabase = inject(SupabaseService);
  auth = inject(AuthService);

  async upload(file: Blob) {
    const newId = uuidv4();
    let fileEnding = file.type.split('/')[1];
    if (file.type === 'audio/mpeg') {
      fileEnding = 'mp3'
    }
    const fileName = `${newId}.${fileEnding}`;

    const {data, error} = await this.supabase.client
      .storage
      .from('images')
      .upload(`${this.auth.userId}/${fileName}`, file);

    if (error) {
      console.error(error);
    }

    return fileName;
  }

  async download(fileName: string) {
    const {data, error} = await this.supabase.client
      .storage
      .from('images')
      .download(`${this.auth.userId}/${fileName}`);

    if (!data) {
      console.error(`Could not load image: '${fileName}'`)
    }

    return data;
  }

  async createSignedUrl(fileName: string) {
    const {data, error} = await this.supabase.client
      .storage
      .from('images')
      .createSignedUrl(`${this.auth.userId}/${fileName}`, 60 * 10);

    if (!data) {
      console.error(`Could not load image: '${fileName}'`)
    }

    return data?.signedUrl;
  }
}
